/** Gap between stacked event bars in the month rows and the all-day header. Below one design-system step, so those grids stay hand-written. */
export const EVENT_ROW_GAP = '2px';
